/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListRound = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm17 2v2H10v-2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm17 2v2H10v-2zM5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm17 2v2H10V4zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgListRound as ListRound };
